export default `

.btn,
.btn-default-wl,
.btn-cancel-wl,
.btn-default-outline-wl,
.btn-outline-wl,
.MuiButton-root {
  border-radius: var(--button-border-radius);
}

.btn-default-wl {
  background-color: var(--button-primary-color) !important;
  color: var(--button-primary-text-color) !important;
  border: none;
  width: 90%;
  min-height: 48px;
  height: auto;
  padding: 14px 24px;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.5;
  &:disabled {
    background-color: var(--button-primary-color) !important;
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.btn-cancel-wl {
  border-color: var(--button-primary-color) !important;
  min-height: 48px;
  height: auto;
  padding: 14px 24px;
  width: 90%;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.5;
  &:disabled {
    border-color: var(--text-dark) !important;
  }
}

.btn-default-outline-wl {
  background-color: var(--light-wl-gray) !important;
  color: white !important;
  min-height: 48px;
  height: auto;
  padding: 14px 24px;
  border: none;
  width: 90%;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.5;
}

.btn-outline-wl {
  background-color: white !important;
  color: var(--button-primary-color) !important;
  min-height: 48px;
  height: auto;
  padding: 14px 24px;
  border: 1px solid var(--button-primary-color) !important;
  width: 90%;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1.5;
}
`;
